import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toggle-visibility-popover',
  templateUrl: './toggle-visibility-popover.component.html',
  styleUrls: ['./toggle-visibility-popover.component.scss'],
})
export class ToggleVisibilityPopoverComponent implements OnInit {

  public assetType: string;

  constructor() { }

  ngOnInit() {}

}
